import {Select} from '@dropbox/dig-components/text_fields';
import {t} from 'i18next';

export const NotificationTypeSelect = ({
  error,
  value,
  onSelect,
}: {
  error?: boolean;
  value?: string;
  onSelect: (type: string) => void;
}) => {
  return (
    <Select
      id="type"
      value={value}
      placeholder="— Select —"
      onChange={onSelect}
      isInvalid={error && !value}
    >
      {['workstream_updates', 'workstream_readiness_attention', 'generic'].map((option) => (
        <Select.Option key={option} value={option}>
          {option === 'workstream_readiness_attention'
            ? t('readiness_attention_notification')
            : t(option)}
        </Select.Option>
      ))}
    </Select>
  );
};
